/**
 * FacetWP
 */

// document content loaded
document.addEventListener("DOMContentLoaded", (event) => {

  // submit button active state
  jQuery(document).on('click', '.property-search__submit-filter button', function () {
    var submit_button = jQuery('.fwp-submit');

    if (submit_button.length) {
      jQuery('.property-search__submit-filter-button').removeClass('active');
      jQuery(this).addClass('active');
    }
  })

  // pager scroll - https://gist.github.com/djrmom/971940882f87a5ce0bdcdfd83ae8a9ae
  jQuery(document).on('facetwp-refresh', function() {

    // show category spesific content
    var category_content = document.querySelectorAll('.property-search__category-content');

    var hobbies = FWP.facets.kohteet_harrastusmahdollisuudet;
    var info = FWP.facets.kohteet_lisatieto;

    if (category_content) {

      if(hobbies || info) {
        category_content.forEach((value) => {

          var hobbies_attribute = value.getAttribute('data-hobbies-content');
          var info_attribute = value.getAttribute('data-info-content');

          if (hobbies.includes(hobbies_attribute) || info.includes(info_attribute)) {
            value.style.display = 'block';
          } else {
            value.style.display = 'none';
          }
        });
      }
    }

    var locations = FWP.facets.kohteet_sijainti;

    if ('undefined' !== typeof FWP.facets.kohteet_sijainti) {

      jQuery('.content-image-block').removeClass('show-term-content');

      if (locations.length == 1) {
        jQuery('.content-image-block').each(function(){
          if (jQuery(this).hasClass('term-' + locations[0])) {
            jQuery(this).addClass('show-term-content');
          }
        });
      }

      if (locations.length > 1 || locations.length == 0) {
        jQuery('.sijainti-term-content-general').addClass('show-term-content');
      }
    }

    if (FWP.settings.kohteet_sijainti) {
      get_locations(locations);
    }

    if ( FWP.soft_refresh == true ) {
      FWP.enable_scroll = true;
    } else {
      FWP.enable_scroll = false;
    }
  });

  jQuery(document).on('facetwp-loaded', function() {

    // show expanded facetwp search box when user came from archive link
    const url_params = new URLSearchParams(window.location.search);
    const search_param = url_params.get('hakuehdot');

    if(search_param == 'muokkaa') {
      var element = document.getElementById('toggle-content');

      if(element) {
        // element.setAttribute("data-a11y-toggle-open", "");
        element.setAttribute("aria-hidden", "false");
      }
    }

    // show contact list when filter is selected

    if ('undefined' !== typeof FWP.facets['kontaktit']) {
      if (FWP.facets.kontaktit.length) {
        jQuery('.contact-persons-block .facetwp-template').addClass('visible');
      } else {
        jQuery('.contact-persons-block .facetwp-template').removeClass('visible');
      }
    }

    // add total count to submit button and hero small title
    var total = FWP.settings.pager.total_rows;


    if (total == 0) {
      // hide title
      jQuery('.facetwp-count').parent('span').hide();
    }

    var submit = jQuery('.fwp-submit-count');
    var title = jQuery('.facetwp-count');

    jQuery(submit).text('(' + total + ')');
    jQuery(title).text(total);

    if (jQuery('.facetwp-pager').length) {

      // pager scroll
      if ( FWP.enable_scroll == true ) {
        jQuery('html, body').animate({
          scrollTop: jQuery('.facetwp-pager-anchor').offset().top - 120
        }, 500);
      }
    }

   });

   function get_locations(locations) {

      var all_locations = '';
      var counter = 0;

      locations.forEach(function(location) {

        // get label by data-value attr
        var location_label = jQuery('.fs-option[data-value="' + location + '"]');

        if (location_label.length) {

          location_label = location_label[0].innerText;

          // strip everythin inside brackets ()
          location_label = location_label.replace(/ *\([^)]*\) */g, "");

          // add location to string
          if (counter == 0) {
            all_locations += location_label;
          } else {
            all_locations += ', ' + location_label;
          }
        }

        counter++;
      });

      if (jQuery('.hero-location').length) {
        jQuery('.hero-location').text(' ' + all_locations);
      }
   }

});
